import { useTranslation } from "react-i18next";
import { Label } from "../../forms/Label/Label";
import { Select, TSelectOption } from "../../forms/Select";

type TViewTypeDropdownProps = {
  selVal?: string;
  onHierarchyTypeSel: (value: string) => void;
};

const ViewHierarchyTypesList = ({
  selVal,
  onHierarchyTypeSel,
}: TViewTypeDropdownProps) => {
  const { t } = useTranslation(["common"]);

  const viewTypeMenuItems = [
    { value: "all", label: "Organization-wide" },
    { value: "under_hierarchy", label: "My Hierarchy" },
    { value: "my", label: "My Performance" },
  ];

  return (
    <>
      <Label weight={"medium"} htmlFor="hierarchyScope">
        {t("FILTER.HIERAR_TYPE")}
      </Label>
      <Select
        name="hierarchyScope"
        options={viewTypeMenuItems}
        value={viewTypeMenuItems?.find((item) => item.value === selVal) ?? null}
        onChange={(option: TSelectOption | null) =>
          onHierarchyTypeSel(option?.value ?? "")
        }
        getOptionLabel={(option: TSelectOption) => option.label}
        getOptionValue={(option: TSelectOption) => option.value}
        placeholder={t("FILTER.SELECT_HIERAR_TYPE")}
        className="text-sm"
        isClearable={false}
      />
    </>
  );
};

export default ViewHierarchyTypesList;
